module.exports = __webpack_public_path__ + "static/media/image10.ba20d42b.png";